export default "__VITE_ASSET__TiymBy9G__"